<template>
  <div class="mt-20 flex flex-col items-center p-x2 lg:px-10 rounded-xl py-10
    bg-beige-academy-100">
    <masterclass-heading :masterclass="masterclass" :isTeacher="true" class="mb-10 w-11/12
    lg:w-5/6"/>

    <div class="flex justify-center w-full font-sans-serif lg:w-5/6">
      <div class="flex flex-col items-end w-1/2 ml-6">
        <span> {{$t('masterclass.registered')}} </span>
        <span> {{$t('masterclass.places')}}: </span>
      </div>
      <div class="flex flex-col items-start ml-4 w-1/2 font-sans-serif">
        <span> {{ masterclass.participantsNumber }}</span>
        <span> {{ masterclass.freePlaces ? masterclass.freePlaces : 'illimitati' }} </span>
      </div>

    </div>

    <div v-if="!masterclass.slide_url">
      <span class="font-sans-serif">{{$t('masterclass.no-slides')}}</span>
      <button @click="openFileManager"
        class="mt-20 ml-4 rounded-full shadow-md w-auto p-2 border border-grey-academy-200
        text-md uppercase text-left transform hover:-translate-y-1 duration-300 bg-white">
          {{$t('masterclass.load-slides')}}
      </button>

    </div>
    <div v-else class="mt-20">
      <span class="text-beige-academy-500">{{masterclass.slide_name}}</span>
      <button @click="openFileManager"
        class="ml-4 border-b border-orange-academy-300 mx-auto
        text-md px-2 uppercase text-left transform hover:-translate-y-1 duration-300">
          {{$t('masterclass.change-slides')}}
      </button>
    </div>

    <button @click="startMasterclass"
      class="mt-14 bg-grey-academy-200 w-64 rounded-full mx-auto text-xl shadow-lg
        p-3 uppercase transform hover:scale-105 duration-300 text-chocolate-academy-600">
         {{$t('masterclass.start')}}
    </button>

    <modal resizable name="slide-uploader" height="auto" :adaptive="true">
      <file-uploader class="w-full"
        :id="masterclass.id" />
    </modal>

  </div>
</template>

<script>
import axios from 'axios';
import DatesConversion from '@/mixins/DatesConversion';
import { mapGetters, mapActions } from 'vuex';
import FileUploader from '../fileUpload/FilesManager.vue';
import MasterclassHeading from './MasterclassHeading.vue';

export default {
  components: {
    FileUploader,
    MasterclassHeading,
  },

  data() {
    return {
      masterclass: '',
      slide: null,
    };
  },

  computed: {
    ...mapGetters({
      choosenTimezone: 'timezone/choosenTimezone',
      user: 'auth/user',
      beenUpdatedSlots: 'slots/updatedSlots',
    }),

  },

  watch: {
    beenUpdatedSlots() {
      this.getMasterclass();
      this.updatedSlots(false);
    },
  },

  mixins: [DatesConversion],

  created() {
    this.getMasterclass();
  },

  methods: {
    ...mapActions({
      updatedSlots: 'slots/updatedSlots',
    }),

    getMasterclass() {
      axios.get(`/api/masterclasses/${this.$route.params.id}`).then(({ data }) => {
        this.masterclass = data;
      });
    },

    openFileManager() {
      this.$modal.show('slide-uploader');
    },

    startMasterclass() {
      axios.get(`/api/masterclasses/${this.$route.params.id}/start-url`).then(({ data }) => {
        window.location.href = data;
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorTryAgain'));
      });
    },
  },
};
</script>
